import { render, staticRenderFns } from "./CKdiaobo-view.vue?vue&type=template&id=3b982af9&scoped=true&"
import script from "./CKdiaobo-view.vue?vue&type=script&lang=js&"
export * from "./CKdiaobo-view.vue?vue&type=script&lang=js&"
import style0 from "./CKdiaobo-view.vue?vue&type=style&index=0&id=3b982af9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b982af9",
  null
  
)

export default component.exports